import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";
import { toAbsoluteUrl } from "src/_metronic/helpers";
import { Template } from "src/app/types/templates";
export interface ITemplateRow {
    template: Template;
    onSelected?(template: Template): void;
    isSelected?: boolean;
    hasDisable?: boolean;
    onEdit?(): void;
    onDisable?(): void;
}
const TemplateRow = (props: ITemplateRow) => {
    const {
        template,
        onSelected = () => {},
        onEdit = () => {},
        onDisable = () => {},
        isSelected = false,
        hasDisable = true,
    } = props;
    const { formatMessage } = useIntl();

    return (
        <div
            className={`templateRowWrapper ${!template?.active ? "disable" : ""} ${
                isSelected ? "isSelected" : ""
            }`}
            onClick={() => onSelected(template)}
        >
            <div className="headers">
                <div className="text">
                    <span>
                        {formatMessage({ id: "common.field.title" })} :{" "}
                        {template?.title || "default Title"}
                    </span>
                    <span>
                        {" "}
                        {formatMessage({ id: "common.field.tag" })} :{" "}
                        {formatMessage({ id: `common.field.tagType.${template.tag}` })}
                    </span>
                </div>
                <div className="iconsWrapper">
                    <div
                        className="iconWrapper"
                        onClick={(e) => {
                            e.stopPropagation();
                            onEdit();
                        }}
                    >
                        <SVG
                            width={16}
                            src={toAbsoluteUrl(`/media/icons/duotune/general/gen055.svg`)}
                        />
                    </div>
                    {hasDisable && (
                        <div
                            className="iconWrapper"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDisable();
                            }}
                        >
                            {template?.active ? (
                                <SVG
                                    width={16}
                                    src={toAbsoluteUrl(`/media/icons/duotune/general/cross.svg`)}
                                />
                            ) : (
                                <SVG
                                    width={16}
                                    src={toAbsoluteUrl(`/media/icons/duotune/general/tick.svg`)}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
            <hr className="divider" />
        </div>
    );
};

export default TemplateRow;
